// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 1679196484
import { createAction } from 'typesafe-actions';

export const setActiveAccountIds = createAction('INVESTMENTS/SET_ACTIVE_ACCOUNT_IDS')<string[]>();
